import { render, staticRenderFns } from "./productModel.vue?vue&type=template&id=970cb090&scoped=true"
import script from "./productModel.vue?vue&type=script&lang=js"
export * from "./productModel.vue?vue&type=script&lang=js"
import style0 from "./productModel.vue?vue&type=style&index=0&id=970cb090&prod&scoped=true&lang=css"
import style1 from "./productModel.vue?vue&type=style&index=1&id=970cb090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970cb090",
  null
  
)

export default component.exports